import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
  Button,
  type ButtonProps,
} from '@agria/theme/src/components/button/Button';

const StyledSkipLink = styled(Button)`
  ${({ theme: { space } }) => css`
    position: absolute;
    z-index: 1;
    margin: ${space.xSmall};

    &:not(:focus) {
      /* Match visuallyHidden Typography */
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
    }
  `};
`;

export const SkipLink: FC<ButtonProps> = (props) => (
  <StyledSkipLink as="a" href="#main" notFullWidth {...props}>
    Skip to main content
  </StyledSkipLink>
);
